<template>
<div>
  <b-navbar toggleable="lg" type="dark" variant="primary">
    <b-navbar-brand to="/public-collections">Collectibles</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <em>Collection</em>
          </template>
          <b-dropdown-item to="/collections">Collections</b-dropdown-item>
          <b-dropdown-item to="/collection-images">Images</b-dropdown-item>
          <b-dropdown-item to="/storage-spaces">Storage Spaces</b-dropdown-item>
          <b-dropdown-item to="/showings">Showings</b-dropdown-item>
          <b-dropdown-item to="/product-items">Assets</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <em>Product</em>
          </template>
          <b-dropdown-item to="/interests">Interests</b-dropdown-item>
          <b-dropdown-item to="/brands">Brands</b-dropdown-item>
          <b-dropdown-item to="/product-models-screen">Models</b-dropdown-item>
          <b-dropdown-item to="/product-listings-screen">Listings</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <em>Team</em>
          </template>
          <b-dropdown-item to="/work-groups">Work Groups</b-dropdown-item>
          <b-dropdown-item to="/actor-roles">Actor Roles</b-dropdown-item>
          <b-dropdown-item to="/profiles">Profiles</b-dropdown-item>
          <b-dropdown-item to="/users">Users</b-dropdown-item>
        </b-nav-item-dropdown>
        <!-- <b-nav-item to="/polymorphic-references">Info</b-nav-item>
        <b-nav-item to="/features">Help</b-nav-item> -->
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <em>Help</em>
          </template>
          <b-dropdown-item to="/features">Features</b-dropdown-item>
          <b-dropdown-item to="/polymorphic-references">Products</b-dropdown-item>
          <b-dropdown-item to="/poly-integer-references">Interests</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-form>
          <b-form-input size="sm" class="mr-sm-2" placeholder="Search" v-model="search_text"></b-form-input>
          <b-button size="sm" type="submit" @click="searchFor">Search</b-button>
        </b-nav-form> -->

        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <em>User</em>
          </template>
          <b-dropdown-item to="/signup">Sign Up</b-dropdown-item>
          <!-- <b-dropdown-item href="#">Profile</b-dropdown-item> -->
          <b-dropdown-item to="/signin">Sign In</b-dropdown-item>
          <b-dropdown-item @click="logout">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</div>
</template>

<script>
import {http_v1} from '@/axios'

export default {
// data() {
//     return {
//       search_text: ''
//     }
//   },
  methods: {
    logout() {
        http_v1.delete (
        'logout', {
        }
      ).then(() => {
          this.$router.push({path: '/signin'})
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    // searchFor() {
    //   window.console.log("searching for " + this.search_text)
    //   this.$router.push(
    //     {
    //       name: 'ProductListingIndex',
    //       params: {
    //         'product_model_name': this.search_text
    //       }
    //     }
    //   )
    // }
  }
}
</script>
